var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tabs",staticClass:"tabs"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"tab",class:{ 'tab-active': _vm.tabActive(item.id) },on:{"click":function($event){return _vm.onSelect(item.id)}}},[_vm._v(" "+_vm._s(item.name)+" "),(_vm.isShowDivider(index))?_c('div',{staticClass:"divider"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }